export default __webpack_public_path__ + "static/media/2370.c774abb0.png";